module.exports = __webpack_public_path__ + "img/brand_logo_w_pc.e04d3009.png";